import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query";
import { LocalStoreKey, LocalStoreManager } from "../../utils/LocalStoreManager";

const customFetchBase = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_SERVER_ENDPOINT}/api/`,
  credentials: 'include',
  jsonContentType: 'application/json',
  prepareHeaders: (headers) => {
    const token = LocalStoreManager.get(LocalStoreKey.LOCALSTORE_TOKEN);

    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }

    return headers
  },
})

export default customFetchBase;